
const eventview = [{"key":"eventview.title","string":"Wydarzenie dodane przez Ciebie"},{"key":"eventview.add_event_button","string":"Dodaj wydarzenie"},{"key":"eventview.no_event_added","string":"Do tej pory nie dodałeś rzadnego wydarzenia do platformy eksperckiej projektu GeoPLASMA-CE"},{"key":"eventview.table.title","string":"Tytuł"},{"key":"eventview.table.location","string":"Lokalizacja"},{"key":"eventview.table.date","string":"Data"},{"key":"eventview.gotowebsite","string":"Przejdź do strony wydarzenia"}]

export default eventview



// WEBPACK FOOTER //
// ./src/i18n/pl/addevent/eventview.js